import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { injectStripe } from 'react-stripe-elements';
import apiManager from '../../../src/ApiManager';

const IS_LOCAL = window.location.hostname === 'localhost';
const BASE_URL = IS_LOCAL ? 'http://localhost:3000' : ''; // TODO: STAGE/PROD URLS
const API_BASE_URL = IS_LOCAL ? 'http://localhost:8050' : ''; // TODO: STAGE/PROD URLS

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 10,
      listStyle: 'disc',
    },
  },
  appBar: {
    // borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {},
  heroContent: {},
  cardHeader: {},
  cardHeaderStandard: {
    backgroundColor: '#0a1241',
    color: 'white',
    fontSize: 10,
  },
  cardHeaderPlus: {
    backgroundColor: '#25C2F4',
    color: 'white',
    fontSize: 32,
    height: 80,
  },
  priceStandard: {
    fontSize: 22,
    fontWeight: 300,
    display: 'inline-block',
  },
  pricePlus: {
    fontWeight: 300,
    display: 'inline-block',
    marginLeft: -16,
  },
  priceDollar: {
    display: 'inline-block',
    paddingTop: 11,
  },
  priceEnterprise: {
    fontSize: 18,
    fontWeight: '600',
  },
  price2: {
    fontWeight: 300,
    fontSize: 16,
  },
  cardPricing: {
    // display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    textAlign: 'center',
    marginBottom: '8px',
  },
  footer: {
    //  borderTop: `1px solid ${theme.palette.divider}`,

    paddingTop: '8px',
    paddingBottom: '8px',
  },
}));

const products = {
  stage: {
    basicProductPlan: 'price_1HXW4KKpahKRcWFg4MtFro4H',
  },
  prod: {
    basicProductPlan: '', //TODO
  },
};

const tiers = [
  {
    title: 'ActivMedia Subscription',
    price: '5',
    type: 0,
    price2: 'USD/mo',
    subheader: 'Create unlimited AcivVideos',
    currency: '$',
    phase: 'stage',
    descriptionTitle: 'Storgage up to 1GB',
    subscription: products.stage.basicProductPlan,
    description: [
      'Unlimited Access to Featured ActivVideos',
      'Create unlimited ActivVideos',
      'Free Personal Channel',
    ],
    buttonText: 'Sign up Now',
    buttonVariant: 'outlined',
  },
  {
    title: 'Regenerative Ag 101',
    // subheader: 'Most popular',
    subheader: 'Full Course Access',
    price: '500',
    currency: '$',
    benefits: 'Standard',
    descriptionTitle: 'Full Regenerative Ag 101 Course Access',
    type: 1,
    price2: 'USD',
    subscription: products.stage.basicProductPlan,
    description: ['Full Access to 101 Course', 'Discount on Subsequent Courses', 'Comment and Chat in Courseware'],
    buttonText: 'Subscribe Now',
    buttonVariant: 'contained',
  },
  //   {
  //     title: 'Enterprise',
  //     currency: '',
  //     price: '',
  //     type: 2,
  //     benefits: 'Plus',
  //     descriptionTitle: 'Unlimited Briefs',
  //     subheader: 'For large businesses providing multiple teams insights reporting across depts',
  //     subscription: products.stage.tmreProductPlan,
  //     price2: '',
  //     description: [
  //       'Tailored human support',
  //       'Real-time analytics dashboard to keep you informed of who and what insights are being used',
  //       'Custom company branded portal',
  //       'API integrations: Slack, Dropbox, etc.'
  //     ],
  //     buttonText: 'Contact us',
  //     buttonVariant: 'outlined',
  //   },
];
const footers = [
  {
    title: 'Company',
    description: ['Team', 'History', 'Contact us', 'Locations'],
  },
  {
    title: 'Features',
    description: ['Cool stuff', 'Random feature', 'Team feature', 'Developer stuff', 'Another one'],
  },
  {
    title: 'Resources',
    description: ['Resource', 'Resource name', 'Another resource', 'Final resource'],
  },
  {
    title: 'Legal',
    description: ['Privacy policy', 'Terms of use'],
  },
];

export default function Subscriptions(props) {
  const classes = useStyles();

  const { user, apiManager } = props;

  const [subscription, setSubscription] = React.useState(false);
  const [init, setInit] = React.useState(false);
  const [token, setToken] = React.useState('');

  const getSubscription = async () => {
    const data = await apiManager.getSubscription();
    console.log(data);

    setSubscription(data);
  };

  if (!init && !subscription) {
    setInit(true);
    // getSubscription();
  }

  const stripe = window.Stripe(
    'pk_test_51HUcxzKpahKRcWFgEnjbgYGeUHRZngKxtTPkPEl1GyIo5bfO8lulxFr02hYHUjeTTHMKtUvd96FF1XO0ohM6icPQ00YAtrY86c'
  );
  // const stripe = {};

  const renderCheckoutButton = (tier) => {
    const { title } = tier;
    let html = '<div></div>';
    if (title === 'Regenerative Ag 101') {
      // Standard
      html = (
        <Button
          type="submit"
          fullwidth
          style={{ width: '100%' }}
          variant="contained"
          className="breefly-btn-primary"
          id={`checkout-button-${products.stage.basicProductPlan}`}
          onClick={stripeStandardCheckout}
        >
          {isSubscription && tier.subscription == subscription.session.display_items[0].plan.id
            ? 'My Plan'
            : 'Downgrade'}
        </Button>
      );
    } else if (title === 'Plus') {
      html = (
        <Button
          className="breefly-btn-primary"
          type="submit"
          style={{ width: '100%' }}
          fullwidth
          variant="contained"
          id={`checkout-button-${products.stage.proProductPlan}`}
          onClick={stripePlusCheckout}
        >
          {isSubscription && tier.subscription == subscription.session.display_items[0].plan.id
            ? 'My Plan'
            : 'Upgrade'}
        </Button>
      );
    } else if (title === 'Enterprise') {
      html = (
        <Button
          className="breefly-btn-primary"
          type="submit"
          fullwidth
          style={{ width: '100%' }}
          variant="contained"
          id={`checkout-button-${products.stage.proProductPlan}`}
          onClick={stripePlusCheckout}
        >
          Contact Sales
        </Button>
      );
    }
    return html;
  };

  const stripeStandardCheckout = async () => {
    const { accessToken } = await apiManager.currentSession();
    const successUrl = `${BASE_URL}/subscription/success/{CHECKOUT_SESSION_ID}/`;
    const webUrl = `${BASE_URL}`;

    alert(`${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(accessToken.jwtToken));

    stripe.redirectToCheckout({
      items: [{ plan: products.stage.basicProductPlan, quantity: 1 }],
      successUrl: `${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(accessToken.jwtToken),
      cancelUrl: webUrl + '/subscription/error', // /#error
    });
  };

  const stripePlusCheckout = () => {
    // const successUrl = 'http://localhost:8020/api/v1/subscriptions/success/{CHECKOUT_SESSION_ID}/';
    // const webUrl = 'http://localhost:3000';
    // stripe.redirectToCheckout({
    // 		items:  [{plan: products.stage.proProductPlan, quantity: 1}],
    // 		successUrl: `${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(user.token),
    // 		cancelUrl: webUrl + '/#error',
    // 	  })
  };

  const renderSubscription = () => {
    // if(subscription){

    //   return (<div style={{ textAlign: 'center' }}><h3>My Subscription: {subscription.session.display_items[0].plan.nickname }</h3></div>)
    // }
    return null;
  };

  const isSubscription = subscription && subscription.session;

  return (
    <div style={{ margin: 48 }}>
      <Container maxWidth="md" component="main" className={classes.heroContent}>
        <Typography component="h1" variant="h5" align="center" color="textPrimary" gutterBottom>
          Subscribe Today!
        </Typography>
        {/* <Typography variant="body1" align="center" color="textSecondary" component="p">
        Start your 14-day FREE trial today!
        </Typography> */}
      </Container>
      {renderSubscription()}
      {/* End hero unit */}
      <Container style={{ marginBottom: 48 }} maxWidth="md">
        <Grid container spacing={0} alignItems="center">
          {tiers.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid item xs={6}>
              <Card style={{ height: '550px', maxWidth: '350px' }}>
                <div style={{ height: '3px', background: '#000055' }}></div>

                <CardHeader title={tier.title} subheader={tier.subheader} />
                <CardContent>
                  <div>
                    <Typography variant="body1" color="textPrimary">
                      <div className={classes.priceDollar}>{tier.currency}</div>{' '}
                      <div className={classes.priceStandard}>
                        {tier.price ? tier.price : ''} <span className={classes.price2}>{tier.price2}</span>
                      </div>
                    </Typography>
                    {renderCheckoutButton(tier)}
                    <div style={{ height: '50px', paddingTop: '20px' }}>
                      {tier.type > 0 ? `All the benefits of ${tier.benefits}, and:` : ''}
                    </div>
                  </div>
                  <div>
                    <Typography component="p" variant="body1">
                      {tier.descriptionTitle}
                    </Typography>
                    Total number of briefs in your account
                  </div>
                  <br />
                  <ul>
                    {tier.description.map((line) => (
                      <Typography component="li" variant="body1" key={line}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <div style={{ textAlign: 'center', width: '100%', marginBottom: 24 }}></div>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
